// extracted by mini-css-extract-plugin
export default {"status":"StatusIndicator_status__8vHyF","outer":"StatusIndicator_outer__dGMHY","inner":"StatusIndicator_inner__DVC-S","text":"StatusIndicator_text__MSJQ6"};